// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage-module__error__bE-Xk","feedback":"ErrorMessage-module__feedback__jfvSa","absolute":"ErrorMessage-module__absolute__KOnYt"};